// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27%3E%3Cpath d=%27M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112zm56 224a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27%3E%3Cpath d=%27M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27 fill=%27%237d7d7d%27%3E%3Cpath d=%27M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Create Account App - WV Design System Aligned
   Tokens from: https://vvevoda.github.io/WV-Design-System/
   Source CSS: vvevoda/WV-Design-System/docs/styles.css */

/* --- DS Custom Properties (scoped to avoid leaking) --- */
.create-account {
  /* Surfaces */
  --surface-page: #fafafa;
  --surface-default-container: #fdfdfd;
  --surface-top-container: #f5f5f5;
  --surface-disabled: #f5f5f5;
  --surface-action-hover: #f78958;
  --surface-error: #fff1f1;
  --surface-success: #f1f7f2;

  /* Text */
  --text-headings: #393939;
  --text-body: #464646;
  --text-captions: #666666;
  --text-placeholder: #7d7d7d;
  --text-action: #e96620;
  --text-action-hover: #f78958;
  --text-action-on-hover: #fff1eb;
  --text-action-on-pressed: #ffc7ae;
  --text-action-disabled: #979797;
  --text-action-on: #ffffff;
  --text-status-error: #de515e;
  --text-status-success: #438558;

  /* Borders */
  --border-default: #e9e9e9;
  --border-accent: #d0d0d0;
  --border-action: #f78958;
  --border-action-hover: #ffa984;
  --border-action-pressed: #e96620;
  --border-disabled: #e9e9e9;
  --border-error: #f88c90;
  --border-success: #438558;

  /* Radii */
  --radius-s: 4px;
  --radius-m: 8px;
  --radius-xxl: 48px;

  /* Spacing */
  --padding-s: 8px;
  --padding-s-m: 12px;
  --padding-m: 16px;
  --padding-l: 24px;
  --padding-xl: 32px;
  --padding-xxl: 48px;
  --row-gap-section: 64px;
  --jumper-xxxs-tiny: 8px;

  /* Typography */
  --font-primary: 'Lato', sans-serif;
  --h5-size: 24px;
  --h5-line: 28px;
  --body-m-size: 16px;
  --body-m-line: 24px;
  --body-s-size: 14px;
  --body-s-line: 20px;
  --body-xs-size: 12px;
  --body-xs-line: 14px;
  --body-l-size: 20px;
  --body-l-line: 28px;

  /* Buttons */
  --btn-primary-bg: #e96620;
  --btn-primary-bg-hover: #f78958;
  --btn-primary-bg-pressed: #d14000;
  --btn-primary-bg-disabled: #f5f5f5;
  --btn-primary-border: #f78958;
  --btn-primary-border-hover: #ffa984;
  --btn-primary-border-pressed: #e96620;
  --btn-primary-text: #ffffff;
  --btn-primary-text-hover: #fff1eb;
  --btn-primary-text-pressed: #ffc7ae;
  --btn-border-disabled: #e9e9e9;
  --btn-border-width: 2px;
  --btn-radius: 48px;

  /* Shadow */
  --shadow-default: 0px 8px 16px 0px rgba(179, 179, 179, 0.1);
}

/* --- Layout --- */
.create-account {
  display: flex;
  justify-content: center;
  padding: var(--row-gap-section) var(--padding-m);
  min-height: 60vh;
  font-family: var(--font-primary);
}

.create-account__card {
  width: 100%;
  max-width: 480px;
  background: var(--surface-default-container);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-m);
  padding: var(--padding-xxl);
}

.create-account__card--wide {
  max-width: 556px;
  padding: var(--padding-xl);
}

/* --- Step Indicator ---
   Rendered as <ol>/<li>: a non-interactive progress display, not a tab bar.
   Default list styling is reset here so the row reads as plain inline cells. */
.tab-bar {
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid var(--border-default);
  margin: 0 0 var(--padding-xl);
  padding: 0;
  list-style: none;
}

.tab-item {
  display: flex;
  flex: 1 1 0;
  align-items: center;
  justify-content: center;
  gap: var(--padding-s);
  padding: var(--padding-s) var(--padding-s-m);
  position: relative;
  white-space: nowrap;
  font-family: var(--font-primary);
  font-size: var(--body-m-size);
  line-height: var(--body-m-line);
  letter-spacing: 0.16px;
  font-weight: 400;
  color: var(--text-body);
  background: transparent;
  border-bottom: 2px solid transparent;
  box-sizing: border-box;
  transition: background 0.15s ease, color 0.15s ease;
}

.tab-item.selected {
  font-weight: 700;
  border-bottom-color: var(--border-action);
}

.tab-item.is-disabled {
  background: var(--surface-disabled);
  color: var(--text-action-disabled);
}

/* --- Title and Subtitle --- */
.create-account__title {
  font-size: var(--h5-size);
  line-height: var(--h5-line);
  font-weight: 900;
  color: var(--text-headings);
  margin: 0 0 var(--padding-s);
}

.create-account__title--centered {
  text-align: center;
}

.create-account__subtitle {
  font-size: var(--body-m-size);
  line-height: var(--body-m-line);
  color: var(--text-body);
  margin: 0 0 var(--padding-l);
}

/* --- Snackbar (replaces help text) --- */
.snackbar {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  background: var(--surface-default-container);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-m);
  box-shadow: var(--shadow-default);
  overflow: clip;
  margin-bottom: var(--padding-m);
}

.snackbar-content {
  display: flex;
  gap: var(--padding-m);
  align-items: flex-start;
  padding: var(--padding-m);
  width: 100%;
}

.snackbar-icon-text {
  display: flex;
  flex: 1 0 0;
  gap: var(--padding-s);
  align-items: center;
  align-self: stretch;
  min-width: 0;
}

.snackbar-icon {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  color: var(--text-action);
}

.snackbar-icon svg {
  width: 24px;
  height: 24px;
  fill: currentColor;
}

.snackbar-text {
  display: flex;
  flex-direction: column;
  flex: 1 0 0;
  gap: var(--jumper-xxxs-tiny);
  align-items: flex-start;
  min-width: 0;
}

p.snackbar-body,
.snackbar-body {
  font-family: var(--font-primary);
  font-weight: 400;
  font-size: var(--body-m-size);
  line-height: var(--body-m-line);
  letter-spacing: 0.16px;
  color: var(--text-body);
  margin: 0;
}

/* --- Form Overrides --- */
.create-account .wvus-form {
  max-width: 100%;
  margin-bottom: 0;
}

/* Form intro paragraphs ("We found the email ...") match body M body color
   so they're consistent with the confirmation copy on the next screen. */
.create-account .wvus-form > p:not(.error-message):not(.create-account__password-hint) {
  font-size: var(--body-m-size);
  line-height: var(--body-m-line);
  color: var(--text-body);
  margin: 0 0 var(--padding-l);
}

.create-account .form-group {
  margin-bottom: var(--padding-l);
}

/* Country field is required by the API but always "United States" — keep the
   InputControl mounted so its value submits, but hide the visual row. */
.create-account .create-account__country-field {
  display: none;
}

.create-account .form-group label {
  position: relative;
  display: block;
  font-size: var(--body-m-size);
  line-height: var(--body-m-line);
  font-weight: 400;
  color: var(--text-body);
  margin-bottom: var(--padding-s);
}

/* Required-field asterisk: wvus-forms emits "<label>Field <sup>*</sup></label>"
   only for required fields. Hang the asterisk in the label's left margin so it
   reads as a leading ornament without pushing the label text rightward. */
.create-account .form-group label sup {
  position: absolute;
  left: -9px;
  top: 0;
  color: var(--text-status-error);
  font-weight: 700;
  font-size: 1em;
  line-height: inherit;
}

.create-account .form-control {
  height: auto;
  padding: var(--padding-s) var(--padding-s-m);
  font-family: var(--font-primary);
  font-size: var(--body-m-size);
  line-height: var(--body-m-line);
  border: 1px solid var(--border-accent);
  border-radius: var(--radius-m);
  background-color: var(--surface-default-container);
  color: var(--text-body);
  transition: border-color 0.15s ease;
  position: relative;
}

/* :focus-visible (not :focus) so the orange ring only paints on keyboard
   focus. Mouse-clicked inputs and the State dropdown stop showing the ring
   the moment the pointer interaction completes — the dropdown selection no
   longer lingers in the "active" treatment. */
.create-account .form-control:focus-visible {
  border-color: var(--border-action);
  box-shadow: none;
  outline: 2px solid var(--border-action);
  outline-offset: 3px;
}

.create-account .form-control:disabled,
.create-account .form-control[readonly] {
  background-color: var(--surface-disabled);
  border-color: var(--border-disabled);
  color: var(--text-action-disabled);
  cursor: not-allowed;
}

.create-account .form-control::placeholder {
  color: var(--text-placeholder);
}

/* Anchor for the validation icon: wvus-forms sets position: relative here
   normally, but we set it explicitly so the absolute icon below always
   resolves against the wrapper rather than escaping to a higher ancestor. */
.create-account .form-control-wrapper {
  position: relative;
}

/* Validation icon override: hide the FA4 glyph that wvus-forms emits and
   repaint with FA6 Solid via CSS mask. wvus-forms positions <i> absolutely
   inside a span next to the message in .form-control-wrapper; the wrapper
   height changes with the error message, so we use top/bottom: 50% + margin:
   auto + a small translateY tweak to keep the icon visually centered on the
   input regardless of whether a message is rendered. Applied identically to
   error and success states for consistency across every field in the app.

   The [data-field-container] attribute selector raises specificity to
   (0, 1, 3, 0) so we beat Swing DS rules like \`.has-success.has-icon .fa\`
   which sit at (0, 0, 3, 0) and would otherwise force width: 24px / top: 11px. */
.create-account .form-group[data-field-container].has-icon .fa {
  top: 50%;
  bottom: 50%;
  margin: auto;
  right: var(--padding-m);
  width: 20px;
  height: 20px;
  font-size: 0;
  color: transparent;
  -webkit-mask-size: contain;
          mask-size: contain;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
}

/* Error icon (FA Free 6.x Solid circle-exclamation, CC BY 4.0).
   The error message renders inside the wrapper below the input, expanding
   the wrapper height, which shifts the auto-margin centering downward.
   translateY(-60%) lifts the icon back to the input's vertical center. */
.create-account .form-group[data-field-container].has-icon.has-error .fa,
.create-account .form-group[data-field-container].has-icon[data-field-is-valid="false"] .fa {
  background-color: var(--text-status-error);
  transform: translateY(-60%);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

/* Success icon (FA Free 6.x Solid circle-check, CC BY 4.0).
   Two selectors: data-field-is-valid for our own state machine, plus
   .has-success which Swing also targets — we set the value identically
   so we beat their declarations on cascade order regardless of which
   class wvus-forms emits in any given build. */
.create-account .form-group[data-field-container].has-icon[data-field-is-valid="true"] .fa,
.create-account .form-group[data-field-container].has-icon.has-success .fa {
  background-color: var(--text-status-success);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

/* Native <select> styling: kill the OS chevron and paint a Font Awesome 6
   Solid chevron-down (CC BY 4.0) in the right-side padding. The chevron is
   a structural cue ("this is a dropdown") so it stays painted across all
   validation states — unlike inputs, the select doesn't get a success/error
   icon. Validation feedback comes from border-color alone. */
.create-account select.form-control {
  -webkit-appearance: none;
          appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: right var(--padding-s-m) center;
  background-size: 16px 16px;
}

/* Hide the wvus-forms success/error icon for select fields. The chevron and
   border color carry enough signal; the FA icon would either stack with the
   chevron or replace it (both wrong). Text inputs keep their icons via the
   .has-icon .fa rules higher in this file. */
.create-account .form-group:has(select.form-control) .fa {
  display: none;
}

/* When the placeholder option (value="") is the active selection, tint the
   displayed text in placeholder gray to match the Figma spec. As soon as a
   real state is picked, value !== "" and the text returns to body color. */
.create-account select.form-control:has(option[value=""]:checked) {
  color: var(--text-placeholder);
}

/* Reserve right padding inside the input so user-typed text doesn't slide under the icon. */
.create-account .form-group.has-icon .form-control {
  padding-right: calc(var(--padding-m) + 20px + var(--padding-s));
}

/* --- Submit Button (DS Primary, Size M) --- */
.create-account__submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--padding-s);
  width: 100%;
  padding: var(--padding-s) var(--padding-l);
  font-family: var(--font-primary);
  font-size: var(--body-m-size);
  line-height: var(--body-m-line);
  font-weight: 400;
  letter-spacing: 0.01em;
  text-decoration: none;
  text-align: center;
  border-width: var(--btn-border-width);
  border-style: solid;
  border-radius: var(--btn-radius);
  background: var(--btn-primary-bg);
  border-color: var(--btn-primary-border);
  color: var(--btn-primary-text);
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  position: relative;
  overflow: clip;
  margin-top: var(--padding-s);
  box-shadow: none;
  outline: none;
  text-transform: none;
}

.create-account__submit:hover:not(:disabled) {
  background: var(--btn-primary-bg-hover);
  border-color: var(--btn-primary-border-hover);
  color: var(--btn-primary-text-hover);
}

.create-account__submit:active:not(:disabled) {
  background: var(--btn-primary-bg-pressed);
  border-color: var(--btn-primary-border-pressed);
  color: var(--btn-primary-text-pressed);
}

.create-account__submit:focus-visible {
  outline: none;
}

.create-account__submit:focus-visible::after {
  content: '';
  position: absolute;
  inset: -6px;
  border: var(--btn-border-width) solid var(--btn-primary-border);
  border-radius: var(--btn-radius);
  pointer-events: none;
}

.create-account__submit:disabled {
  background: var(--btn-primary-bg-disabled);
  border-color: var(--btn-border-disabled);
  color: var(--text-action-disabled);
  cursor: not-allowed;
}

/* --- Divider --- */
.create-account__divider {
  display: flex;
  align-items: center;
  margin: var(--padding-l) 0;
  width: 100%;
  flex-basis: 100%;
}

.create-account__divider::before,
.create-account__divider::after {
  content: "";
  flex: 1;
  height: 1px;
  background-color: var(--border-default);
}

.create-account__divider-text {
  padding: 0 var(--padding-m);
  font-size: var(--body-m-size);
  line-height: var(--body-m-line);
  color: var(--text-body);
}

/* --- Error Styling (DS Alert Error) --- */
.create-account__error-banner .error-message,
.create-account .wv-create-account-error-message.error-message {
  display: flex;
  align-items: flex-start;
  gap: var(--padding-s);
  padding: var(--padding-s-m);
  background-color: var(--surface-error);
  border: 1px solid var(--border-error);
  border-radius: var(--radius-s);
  color: var(--text-status-error);
  font-size: var(--body-s-size);
  line-height: var(--body-s-line);
  margin-bottom: var(--padding-l);
  animation: create-account__shake 0.4s ease;
}

.create-account .has-error .form-control {
  border-color: var(--border-error);
}

.create-account .has-error .help-block {
  color: var(--text-status-error);
  font-size: var(--body-xs-size);
  line-height: var(--body-xs-line);
  margin-top: var(--padding-s);
}

/* Success border. Declared AFTER :focus-visible and .has-error at the same
   specificity (0,3,0) so it wins on cascade for fields that are valid. */
.create-account .has-success .form-control {
  border-color: var(--border-success);
}

/* When a validated field is keyboard-focused, tint the orange outline to
   match the border color so the ring reads as one validation state instead
   of green-border-with-orange-ring (or red-border-with-orange-ring). */
.create-account .has-success .form-control:focus-visible {
  outline-color: var(--border-success);
}
.create-account .has-error .form-control:focus-visible {
  outline-color: var(--border-error);
}

@keyframes create-account__shake {
  0%, 100% { transform: translateX(0); }
  20% { transform: translateX(-4px); }
  40% { transform: translateX(4px); }
  60% { transform: translateX(-2px); }
  80% { transform: translateX(2px); }
}

/* --- Password Hint (DS hint text pattern) ---
   Matches the DS hint-text spec: body S, captions color, padding-s top spacing.
   Hidden when the password field is in an error state so hint and error never stack. */
.create-account__password-hint {
  font-size: var(--body-s-size);
  line-height: var(--body-s-line);
  color: var(--text-captions);
  margin: 0 0 var(--padding-l);
  padding-top: 0;
}

.create-account .has-error + .create-account__password-hint,
.create-account .form-group.has-error ~ .create-account__password-hint {
  display: none;
}

/* --- Confirmation --- */
.create-account__confirmation {
  text-align: center;
  padding: var(--padding-l) 0;
}

.create-account__confirmation-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto var(--padding-l);
  color: var(--text-action);
}

.create-account__confirmation-icon svg {
  width: 56px;
  height: 56px;
  fill: currentColor;
}

.create-account__confirmation-text {
  font-size: var(--body-m-size);
  line-height: var(--body-m-line);
  color: var(--text-body);
  margin: 0 0 var(--padding-s-m);
}

.create-account__confirmation-cta {
  margin-top: var(--padding-l);
}

/* --- Responsive --- */
@media (max-width: 767px) {
  .create-account {
    padding: var(--padding-xl) var(--padding-m);
  }
  .create-account__card {
    padding: var(--padding-l) var(--padding-l);
    border-radius: var(--radius-m);
  }
  .create-account__card--wide {
    max-width: 100%;
  }
  .create-account__title {
    font-size: var(--body-l-size);
    line-height: var(--body-l-line);
  }
  .tab-item {
    font-size: var(--body-s-size);
    line-height: var(--body-s-line);
  }
}
`, "",{"version":3,"sources":["webpack://./src/create-account.css"],"names":[],"mappings":"AAAA;;yDAEyD;;AAEzD,2DAA2D;AAC3D;EACE,aAAa;EACb,uBAAuB;EACvB,oCAAoC;EACpC,gCAAgC;EAChC,2BAA2B;EAC3B,+BAA+B;EAC/B,wBAAwB;EACxB,0BAA0B;;EAE1B,SAAS;EACT,wBAAwB;EACxB,oBAAoB;EACpB,wBAAwB;EACxB,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,iCAAiC;EACjC,+BAA+B;EAC/B,yBAAyB;EACzB,4BAA4B;EAC5B,8BAA8B;;EAE9B,YAAY;EACZ,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,8BAA8B;EAC9B,gCAAgC;EAChC,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;;EAEzB,UAAU;EACV,eAAe;EACf,eAAe;EACf,kBAAkB;;EAElB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;;EAEvB,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;;EAEnB,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,iCAAiC;EACjC,kCAAkC;EAClC,6BAA6B;EAC7B,mCAAmC;EACnC,qCAAqC;EACrC,2BAA2B;EAC3B,iCAAiC;EACjC,mCAAmC;EACnC,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;;EAElB,WAAW;EACX,2DAA2D;AAC7D;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,gDAAgD;EAChD,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,4CAA4C;EAC5C,uCAAuC;EACvC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,oBAAoB;EACpB,8CAA8C;EAC9C,6BAA6B;EAC7B,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,4CAA4C;EAC5C,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,6BAA6B;EAC7B,+BAA+B;EAC/B,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,oCAAoC;EACpC,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,4CAA4C;EAC5C,uCAAuC;EACvC,8BAA8B;EAC9B,iCAAiC;EACjC,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,4BAA4B;EAC5B,uBAAuB;EACvB,YAAY;AACd;;AAEA;;EAEE,gCAAgC;EAChC,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;yEACyE;AACzE;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;wEACwE;AACxE;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;0EAE0E;AAC1E;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,4CAA4C;EAC5C,gCAAgC;EAChC,6BAA6B;EAC7B,+BAA+B;EAC/B,sCAAsC;EACtC,8BAA8B;EAC9B,kDAAkD;EAClD,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;;;8CAG8C;AAC9C;EACE,kCAAkC;EAClC,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;;EAEE,yCAAyC;EACzC,oCAAoC;EACpC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;4EAE4E;AAC5E;EACE,kBAAkB;AACpB;;AAEA;;;;;;;;;;iFAUiF;AACjF;EACE,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;UAClB,kBAAkB;EAC1B,8BAA8B;UACtB,sBAAsB;EAC9B,6BAA6B;UACrB,qBAAqB;AAC/B;;AAEA;;;yEAGyE;AACzE;;EAEE,0CAA0C;EAC1C,2BAA2B;EAC3B,2DAAuU;UAC/T,mDAA+T;AACzU;;AAEA;;;;+CAI+C;AAC/C;;EAEE,4CAA4C;EAC5C,2DAAgV;UACxU,mDAAwU;AAClV;;AAEA;;;;6DAI6D;AAC7D;EACE,wBAAwB;UAChB,gBAAgB;EACxB,yDAAsU;EACtU,4BAA4B;EAC5B,oDAAoD;EACpD,0BAA0B;AAC5B;;AAEA;;;6CAG6C;AAC7C;EACE,aAAa;AACf;;AAEA;;2EAE2E;AAC3E;EACE,8BAA8B;AAChC;;AAEA,4FAA4F;AAC5F;EACE,+DAA+D;AACjE;;AAEA,+CAA+C;AAC/C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,0CAA0C;EAC1C,gCAAgC;EAChC,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,gCAAgC;EAChC,iCAAiC;EACjC,uCAAuC;EACvC,8BAA8B;EAC9B,eAAe;EACf,4EAA4E;EAC5E,kBAAkB;EAClB,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;EACzC,+CAA+C;EAC/C,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,+DAA+D;EAC/D,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;EACxC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,OAAO;EACP,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA,2CAA2C;AAC3C;;EAEE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,sCAAsC;EACtC,qCAAqC;EACrC,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;yEACyE;AACzE;EACE,mCAAmC;AACrC;;AAEA;;uEAEuE;AACvE;EACE,oCAAoC;AACtC;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;EAClC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC;;AAEA;;uFAEuF;AACvF;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,0CAA0C;IAC1C,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;IACE,6BAA6B;IAC7B,+BAA+B;EACjC;EACA;IACE,6BAA6B;IAC7B,+BAA+B;EACjC;AACF","sourcesContent":["/* Create Account App - WV Design System Aligned\n   Tokens from: https://vvevoda.github.io/WV-Design-System/\n   Source CSS: vvevoda/WV-Design-System/docs/styles.css */\n\n/* --- DS Custom Properties (scoped to avoid leaking) --- */\n.create-account {\n  /* Surfaces */\n  --surface-page: #fafafa;\n  --surface-default-container: #fdfdfd;\n  --surface-top-container: #f5f5f5;\n  --surface-disabled: #f5f5f5;\n  --surface-action-hover: #f78958;\n  --surface-error: #fff1f1;\n  --surface-success: #f1f7f2;\n\n  /* Text */\n  --text-headings: #393939;\n  --text-body: #464646;\n  --text-captions: #666666;\n  --text-placeholder: #7d7d7d;\n  --text-action: #e96620;\n  --text-action-hover: #f78958;\n  --text-action-on-hover: #fff1eb;\n  --text-action-on-pressed: #ffc7ae;\n  --text-action-disabled: #979797;\n  --text-action-on: #ffffff;\n  --text-status-error: #de515e;\n  --text-status-success: #438558;\n\n  /* Borders */\n  --border-default: #e9e9e9;\n  --border-accent: #d0d0d0;\n  --border-action: #f78958;\n  --border-action-hover: #ffa984;\n  --border-action-pressed: #e96620;\n  --border-disabled: #e9e9e9;\n  --border-error: #f88c90;\n  --border-success: #438558;\n\n  /* Radii */\n  --radius-s: 4px;\n  --radius-m: 8px;\n  --radius-xxl: 48px;\n\n  /* Spacing */\n  --padding-s: 8px;\n  --padding-s-m: 12px;\n  --padding-m: 16px;\n  --padding-l: 24px;\n  --padding-xl: 32px;\n  --padding-xxl: 48px;\n  --row-gap-section: 64px;\n  --jumper-xxxs-tiny: 8px;\n\n  /* Typography */\n  --font-primary: 'Lato', sans-serif;\n  --h5-size: 24px;\n  --h5-line: 28px;\n  --body-m-size: 16px;\n  --body-m-line: 24px;\n  --body-s-size: 14px;\n  --body-s-line: 20px;\n  --body-xs-size: 12px;\n  --body-xs-line: 14px;\n  --body-l-size: 20px;\n  --body-l-line: 28px;\n\n  /* Buttons */\n  --btn-primary-bg: #e96620;\n  --btn-primary-bg-hover: #f78958;\n  --btn-primary-bg-pressed: #d14000;\n  --btn-primary-bg-disabled: #f5f5f5;\n  --btn-primary-border: #f78958;\n  --btn-primary-border-hover: #ffa984;\n  --btn-primary-border-pressed: #e96620;\n  --btn-primary-text: #ffffff;\n  --btn-primary-text-hover: #fff1eb;\n  --btn-primary-text-pressed: #ffc7ae;\n  --btn-border-disabled: #e9e9e9;\n  --btn-border-width: 2px;\n  --btn-radius: 48px;\n\n  /* Shadow */\n  --shadow-default: 0px 8px 16px 0px rgba(179, 179, 179, 0.1);\n}\n\n/* --- Layout --- */\n.create-account {\n  display: flex;\n  justify-content: center;\n  padding: var(--row-gap-section) var(--padding-m);\n  min-height: 60vh;\n  font-family: var(--font-primary);\n}\n\n.create-account__card {\n  width: 100%;\n  max-width: 480px;\n  background: var(--surface-default-container);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-m);\n  padding: var(--padding-xxl);\n}\n\n.create-account__card--wide {\n  max-width: 556px;\n  padding: var(--padding-xl);\n}\n\n/* --- Step Indicator ---\n   Rendered as <ol>/<li>: a non-interactive progress display, not a tab bar.\n   Default list styling is reset here so the row reads as plain inline cells. */\n.tab-bar {\n  display: flex;\n  align-items: stretch;\n  border-bottom: 1px solid var(--border-default);\n  margin: 0 0 var(--padding-xl);\n  padding: 0;\n  list-style: none;\n}\n\n.tab-item {\n  display: flex;\n  flex: 1 1 0;\n  align-items: center;\n  justify-content: center;\n  gap: var(--padding-s);\n  padding: var(--padding-s) var(--padding-s-m);\n  position: relative;\n  white-space: nowrap;\n  font-family: var(--font-primary);\n  font-size: var(--body-m-size);\n  line-height: var(--body-m-line);\n  letter-spacing: 0.16px;\n  font-weight: 400;\n  color: var(--text-body);\n  background: transparent;\n  border-bottom: 2px solid transparent;\n  box-sizing: border-box;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.tab-item.selected {\n  font-weight: 700;\n  border-bottom-color: var(--border-action);\n}\n\n.tab-item.is-disabled {\n  background: var(--surface-disabled);\n  color: var(--text-action-disabled);\n}\n\n/* --- Title and Subtitle --- */\n.create-account__title {\n  font-size: var(--h5-size);\n  line-height: var(--h5-line);\n  font-weight: 900;\n  color: var(--text-headings);\n  margin: 0 0 var(--padding-s);\n}\n\n.create-account__title--centered {\n  text-align: center;\n}\n\n.create-account__subtitle {\n  font-size: var(--body-m-size);\n  line-height: var(--body-m-line);\n  color: var(--text-body);\n  margin: 0 0 var(--padding-l);\n}\n\n/* --- Snackbar (replaces help text) --- */\n.snackbar {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  background: var(--surface-default-container);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-m);\n  box-shadow: var(--shadow-default);\n  overflow: clip;\n  margin-bottom: var(--padding-m);\n}\n\n.snackbar-content {\n  display: flex;\n  gap: var(--padding-m);\n  align-items: flex-start;\n  padding: var(--padding-m);\n  width: 100%;\n}\n\n.snackbar-icon-text {\n  display: flex;\n  flex: 1 0 0;\n  gap: var(--padding-s);\n  align-items: center;\n  align-self: stretch;\n  min-width: 0;\n}\n\n.snackbar-icon {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n  color: var(--text-action);\n}\n\n.snackbar-icon svg {\n  width: 24px;\n  height: 24px;\n  fill: currentColor;\n}\n\n.snackbar-text {\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n  gap: var(--jumper-xxxs-tiny);\n  align-items: flex-start;\n  min-width: 0;\n}\n\np.snackbar-body,\n.snackbar-body {\n  font-family: var(--font-primary);\n  font-weight: 400;\n  font-size: var(--body-m-size);\n  line-height: var(--body-m-line);\n  letter-spacing: 0.16px;\n  color: var(--text-body);\n  margin: 0;\n}\n\n/* --- Form Overrides --- */\n.create-account .wvus-form {\n  max-width: 100%;\n  margin-bottom: 0;\n}\n\n/* Form intro paragraphs (\"We found the email ...\") match body M body color\n   so they're consistent with the confirmation copy on the next screen. */\n.create-account .wvus-form > p:not(.error-message):not(.create-account__password-hint) {\n  font-size: var(--body-m-size);\n  line-height: var(--body-m-line);\n  color: var(--text-body);\n  margin: 0 0 var(--padding-l);\n}\n\n.create-account .form-group {\n  margin-bottom: var(--padding-l);\n}\n\n/* Country field is required by the API but always \"United States\" — keep the\n   InputControl mounted so its value submits, but hide the visual row. */\n.create-account .create-account__country-field {\n  display: none;\n}\n\n.create-account .form-group label {\n  position: relative;\n  display: block;\n  font-size: var(--body-m-size);\n  line-height: var(--body-m-line);\n  font-weight: 400;\n  color: var(--text-body);\n  margin-bottom: var(--padding-s);\n}\n\n/* Required-field asterisk: wvus-forms emits \"<label>Field <sup>*</sup></label>\"\n   only for required fields. Hang the asterisk in the label's left margin so it\n   reads as a leading ornament without pushing the label text rightward. */\n.create-account .form-group label sup {\n  position: absolute;\n  left: -9px;\n  top: 0;\n  color: var(--text-status-error);\n  font-weight: 700;\n  font-size: 1em;\n  line-height: inherit;\n}\n\n.create-account .form-control {\n  height: auto;\n  padding: var(--padding-s) var(--padding-s-m);\n  font-family: var(--font-primary);\n  font-size: var(--body-m-size);\n  line-height: var(--body-m-line);\n  border: 1px solid var(--border-accent);\n  border-radius: var(--radius-m);\n  background-color: var(--surface-default-container);\n  color: var(--text-body);\n  transition: border-color 0.15s ease;\n  position: relative;\n}\n\n/* :focus-visible (not :focus) so the orange ring only paints on keyboard\n   focus. Mouse-clicked inputs and the State dropdown stop showing the ring\n   the moment the pointer interaction completes — the dropdown selection no\n   longer lingers in the \"active\" treatment. */\n.create-account .form-control:focus-visible {\n  border-color: var(--border-action);\n  box-shadow: none;\n  outline: 2px solid var(--border-action);\n  outline-offset: 3px;\n}\n\n.create-account .form-control:disabled,\n.create-account .form-control[readonly] {\n  background-color: var(--surface-disabled);\n  border-color: var(--border-disabled);\n  color: var(--text-action-disabled);\n  cursor: not-allowed;\n}\n\n.create-account .form-control::placeholder {\n  color: var(--text-placeholder);\n}\n\n/* Anchor for the validation icon: wvus-forms sets position: relative here\n   normally, but we set it explicitly so the absolute icon below always\n   resolves against the wrapper rather than escaping to a higher ancestor. */\n.create-account .form-control-wrapper {\n  position: relative;\n}\n\n/* Validation icon override: hide the FA4 glyph that wvus-forms emits and\n   repaint with FA6 Solid via CSS mask. wvus-forms positions <i> absolutely\n   inside a span next to the message in .form-control-wrapper; the wrapper\n   height changes with the error message, so we use top/bottom: 50% + margin:\n   auto + a small translateY tweak to keep the icon visually centered on the\n   input regardless of whether a message is rendered. Applied identically to\n   error and success states for consistency across every field in the app.\n\n   The [data-field-container] attribute selector raises specificity to\n   (0, 1, 3, 0) so we beat Swing DS rules like `.has-success.has-icon .fa`\n   which sit at (0, 0, 3, 0) and would otherwise force width: 24px / top: 11px. */\n.create-account .form-group[data-field-container].has-icon .fa {\n  top: 50%;\n  bottom: 50%;\n  margin: auto;\n  right: var(--padding-m);\n  width: 20px;\n  height: 20px;\n  font-size: 0;\n  color: transparent;\n  -webkit-mask-size: contain;\n          mask-size: contain;\n  -webkit-mask-repeat: no-repeat;\n          mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n          mask-position: center;\n}\n\n/* Error icon (FA Free 6.x Solid circle-exclamation, CC BY 4.0).\n   The error message renders inside the wrapper below the input, expanding\n   the wrapper height, which shifts the auto-margin centering downward.\n   translateY(-60%) lifts the icon back to the input's vertical center. */\n.create-account .form-group[data-field-container].has-icon.has-error .fa,\n.create-account .form-group[data-field-container].has-icon[data-field-is-valid=\"false\"] .fa {\n  background-color: var(--text-status-error);\n  transform: translateY(-60%);\n  -webkit-mask-image: url(\"data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath d='M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112zm56 224a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'/%3E%3C/svg%3E\");\n          mask-image: url(\"data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath d='M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112zm56 224a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'/%3E%3C/svg%3E\");\n}\n\n/* Success icon (FA Free 6.x Solid circle-check, CC BY 4.0).\n   Two selectors: data-field-is-valid for our own state machine, plus\n   .has-success which Swing also targets — we set the value identically\n   so we beat their declarations on cascade order regardless of which\n   class wvus-forms emits in any given build. */\n.create-account .form-group[data-field-container].has-icon[data-field-is-valid=\"true\"] .fa,\n.create-account .form-group[data-field-container].has-icon.has-success .fa {\n  background-color: var(--text-status-success);\n  -webkit-mask-image: url(\"data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath d='M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z'/%3E%3C/svg%3E\");\n          mask-image: url(\"data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath d='M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z'/%3E%3C/svg%3E\");\n}\n\n/* Native <select> styling: kill the OS chevron and paint a Font Awesome 6\n   Solid chevron-down (CC BY 4.0) in the right-side padding. The chevron is\n   a structural cue (\"this is a dropdown\") so it stays painted across all\n   validation states — unlike inputs, the select doesn't get a success/error\n   icon. Validation feedback comes from border-color alone. */\n.create-account select.form-control {\n  -webkit-appearance: none;\n          appearance: none;\n  background-image: url(\"data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' fill='%237d7d7d'%3E%3Cpath d='M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right var(--padding-s-m) center;\n  background-size: 16px 16px;\n}\n\n/* Hide the wvus-forms success/error icon for select fields. The chevron and\n   border color carry enough signal; the FA icon would either stack with the\n   chevron or replace it (both wrong). Text inputs keep their icons via the\n   .has-icon .fa rules higher in this file. */\n.create-account .form-group:has(select.form-control) .fa {\n  display: none;\n}\n\n/* When the placeholder option (value=\"\") is the active selection, tint the\n   displayed text in placeholder gray to match the Figma spec. As soon as a\n   real state is picked, value !== \"\" and the text returns to body color. */\n.create-account select.form-control:has(option[value=\"\"]:checked) {\n  color: var(--text-placeholder);\n}\n\n/* Reserve right padding inside the input so user-typed text doesn't slide under the icon. */\n.create-account .form-group.has-icon .form-control {\n  padding-right: calc(var(--padding-m) + 20px + var(--padding-s));\n}\n\n/* --- Submit Button (DS Primary, Size M) --- */\n.create-account__submit {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--padding-s);\n  width: 100%;\n  padding: var(--padding-s) var(--padding-l);\n  font-family: var(--font-primary);\n  font-size: var(--body-m-size);\n  line-height: var(--body-m-line);\n  font-weight: 400;\n  letter-spacing: 0.01em;\n  text-decoration: none;\n  text-align: center;\n  border-width: var(--btn-border-width);\n  border-style: solid;\n  border-radius: var(--btn-radius);\n  background: var(--btn-primary-bg);\n  border-color: var(--btn-primary-border);\n  color: var(--btn-primary-text);\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n  position: relative;\n  overflow: clip;\n  margin-top: var(--padding-s);\n  box-shadow: none;\n  outline: none;\n  text-transform: none;\n}\n\n.create-account__submit:hover:not(:disabled) {\n  background: var(--btn-primary-bg-hover);\n  border-color: var(--btn-primary-border-hover);\n  color: var(--btn-primary-text-hover);\n}\n\n.create-account__submit:active:not(:disabled) {\n  background: var(--btn-primary-bg-pressed);\n  border-color: var(--btn-primary-border-pressed);\n  color: var(--btn-primary-text-pressed);\n}\n\n.create-account__submit:focus-visible {\n  outline: none;\n}\n\n.create-account__submit:focus-visible::after {\n  content: '';\n  position: absolute;\n  inset: -6px;\n  border: var(--btn-border-width) solid var(--btn-primary-border);\n  border-radius: var(--btn-radius);\n  pointer-events: none;\n}\n\n.create-account__submit:disabled {\n  background: var(--btn-primary-bg-disabled);\n  border-color: var(--btn-border-disabled);\n  color: var(--text-action-disabled);\n  cursor: not-allowed;\n}\n\n/* --- Divider --- */\n.create-account__divider {\n  display: flex;\n  align-items: center;\n  margin: var(--padding-l) 0;\n  width: 100%;\n  flex-basis: 100%;\n}\n\n.create-account__divider::before,\n.create-account__divider::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background-color: var(--border-default);\n}\n\n.create-account__divider-text {\n  padding: 0 var(--padding-m);\n  font-size: var(--body-m-size);\n  line-height: var(--body-m-line);\n  color: var(--text-body);\n}\n\n/* --- Error Styling (DS Alert Error) --- */\n.create-account__error-banner .error-message,\n.create-account .wv-create-account-error-message.error-message {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--padding-s);\n  padding: var(--padding-s-m);\n  background-color: var(--surface-error);\n  border: 1px solid var(--border-error);\n  border-radius: var(--radius-s);\n  color: var(--text-status-error);\n  font-size: var(--body-s-size);\n  line-height: var(--body-s-line);\n  margin-bottom: var(--padding-l);\n  animation: create-account__shake 0.4s ease;\n}\n\n.create-account .has-error .form-control {\n  border-color: var(--border-error);\n}\n\n.create-account .has-error .help-block {\n  color: var(--text-status-error);\n  font-size: var(--body-xs-size);\n  line-height: var(--body-xs-line);\n  margin-top: var(--padding-s);\n}\n\n/* Success border. Declared AFTER :focus-visible and .has-error at the same\n   specificity (0,3,0) so it wins on cascade for fields that are valid. */\n.create-account .has-success .form-control {\n  border-color: var(--border-success);\n}\n\n/* When a validated field is keyboard-focused, tint the orange outline to\n   match the border color so the ring reads as one validation state instead\n   of green-border-with-orange-ring (or red-border-with-orange-ring). */\n.create-account .has-success .form-control:focus-visible {\n  outline-color: var(--border-success);\n}\n.create-account .has-error .form-control:focus-visible {\n  outline-color: var(--border-error);\n}\n\n@keyframes create-account__shake {\n  0%, 100% { transform: translateX(0); }\n  20% { transform: translateX(-4px); }\n  40% { transform: translateX(4px); }\n  60% { transform: translateX(-2px); }\n  80% { transform: translateX(2px); }\n}\n\n/* --- Password Hint (DS hint text pattern) ---\n   Matches the DS hint-text spec: body S, captions color, padding-s top spacing.\n   Hidden when the password field is in an error state so hint and error never stack. */\n.create-account__password-hint {\n  font-size: var(--body-s-size);\n  line-height: var(--body-s-line);\n  color: var(--text-captions);\n  margin: 0 0 var(--padding-l);\n  padding-top: 0;\n}\n\n.create-account .has-error + .create-account__password-hint,\n.create-account .form-group.has-error ~ .create-account__password-hint {\n  display: none;\n}\n\n/* --- Confirmation --- */\n.create-account__confirmation {\n  text-align: center;\n  padding: var(--padding-l) 0;\n}\n\n.create-account__confirmation-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto var(--padding-l);\n  color: var(--text-action);\n}\n\n.create-account__confirmation-icon svg {\n  width: 56px;\n  height: 56px;\n  fill: currentColor;\n}\n\n.create-account__confirmation-text {\n  font-size: var(--body-m-size);\n  line-height: var(--body-m-line);\n  color: var(--text-body);\n  margin: 0 0 var(--padding-s-m);\n}\n\n.create-account__confirmation-cta {\n  margin-top: var(--padding-l);\n}\n\n/* --- Responsive --- */\n@media (max-width: 767px) {\n  .create-account {\n    padding: var(--padding-xl) var(--padding-m);\n  }\n  .create-account__card {\n    padding: var(--padding-l) var(--padding-l);\n    border-radius: var(--radius-m);\n  }\n  .create-account__card--wide {\n    max-width: 100%;\n  }\n  .create-account__title {\n    font-size: var(--body-l-size);\n    line-height: var(--body-l-line);\n  }\n  .tab-item {\n    font-size: var(--body-s-size);\n    line-height: var(--body-s-line);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
